// @NOTE: assumes jQuery is included by WP
const $ = jQuery

class fancyLoad {
  constructor () {
    this.$elementsToFancyLoad = $('.nm-module')
    this.$window              = $(window)

    this.onWindowResize()
    this.onWindowScroll(window.scrollY)
    setTimeout(() => {
      document.addEventListener('scroll', this.createFancyAndOffsetsArray)
    }, 800);

  }

  onWindowResize (windowWidth) {
    this.windowHeight         = this.$window.outerHeight()
    this.thresholdPixels      = this.windowHeight * .3
    this.createDivsAndOffsetsArray()
  }

  onWindowScroll (scrollTop) {
    if(this.divsAndOffsetsArray.length < 1) {
      return
    }

    const animationPoint = scrollTop + this.windowHeight - this.thresholdPixels
    var indexesToRemove = []

    for (var i = 0; i < this.divsAndOffsetsArray.length; i++) {
      const elementAndOffset = this.divsAndOffsetsArray[i]


      if(elementAndOffset.offset <= animationPoint) {
        elementAndOffset.element.addClass('post-animation')
        indexesToRemove.push(i)
      }
    }

    for (var j = (indexesToRemove.length - 1); j >= 0; j--) {
      this.divsAndOffsetsArray.splice(indexesToRemove[j], 1)
    }

  }

  createFancyAndOffsetsArray () {
    var windowBottom = $(this).scrollTop() + $(this).innerHeight();
      $(".description").each(function() {
        var objectBottom = $(this).offset().top + $(this).outerHeight() * .5;
        //console.log(objectBottom, "<", windowBottom)
        if (objectBottom < windowBottom) {
          $(this).addClass('fancy-load-animation');
        }
    });
  }

  createDivsAndOffsetsArray () {
    this.divsAndOffsetsArray  = []

    this.$elementsToFancyLoad.each((index, element) => {
      const $element = $(element)
      const elementOffset = element.offsetTop

      this.divsAndOffsetsArray.push({
        offset: elementOffset,
        element: $element
      })
    })
  }

}

export default fancyLoad


// WEBPACK FOOTER //
// ./src/js/custom/fancyLoad/fancyLoad.js